import { LinkParamsFieldNames } from '@components/forms/ItemFields/LinkItemFields';
import { ContentType } from '@models/Content';

const LEGACY_TITLE_KEY = 'TITLE_KEY';
const reservedParamKeys = ['isPromo'];

const reservedParamKeyMap: Partial<Record<ContentType, string[]>> = {
  link: LinkParamsFieldNames,
  page: ['behavior'],
  title: ['orderProvidersById', 'orderProvidersByType', LEGACY_TITLE_KEY],
  unmanaged: ['action', 'behavior'],
};

export const getReservedParamKeysForType = (contentType?: ContentType) => [
  ...reservedParamKeys,
  ...((contentType && reservedParamKeyMap[contentType]) ?? []),
];
